module.exports = __webpack_public_path__ + "assets/f4322402c8be5fb7468513445c5d481b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/channels/ro/2.png
// module id = 351
// module chunks = 1